//Models
PJQ.models.resources = {};

PJQ.models.resources.ResourceAllocationManagerViewSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'resources'
			},
			{
				endpoint: 'settings'
			}
		]);
	}
});

PJQ.models.resources.Resource = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	parse: function (model) {
		if (PJQ.app.session != null && model != null) {
			if (model.userTypeId != null) {
				this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
			}

			if (this.userType === null) {
				this.userType = PJQ.app.session.userTypes.getDefault(true);
			}
		}

		return model;
	}
});

PJQ.models.resources.Project = PJQ.models.BaseModel.extend({
	idAttribute: 'projectId',
	getIsIdAssociated: function (id) {
		return (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESOURCE_ALLOCATION_PRIMARY_ONLY) && ((this.get('userId') === -id) || (this.get('user2Id') === -id))) || (_.size(_.filter(this.get('projectManagers'), function (resource) {
			return resource.id === id;
		})) > 0) || (_.size(_.filter(this.get('superintendents'), function (resource) {
			return resource.id === id;
		})) > 0);
		/*return ((_.size(_.filter(this.get('projectManagers'), function(resource) { return resource.id === id; })) > 0)  ||
			(_.size(_.filter(this.get('superintendents'), function(resource) { return resource.id === id; })) > 0));*/
	},
	getIsSimple: function () {
		return ((_.size(_.filter(this.get('projectManagers'), function (resource) {
				return resource.startDate !== null || resource.endDate !== null;
			})) === 0) &&
			(_.size(_.filter(this.get('superintendents'), function (resource) {
				return resource.startDate !== null || resource.endDate !== null;
			})) === 0));
	},
	getProjectResource: function (id) {
		return _.find(_.union(this.get('projectManagers'), this.get('superintendents')), function (item) {
			return item.id === id;
		});
	},
	getProjectResourceDates: function (id) {
		let projectResource = this.getProjectResource(id);
		return {
			startDate: (projectResource && projectResource.startDate) ? projectResource.startDate : this.get('startDate'),
			endDate: (projectResource && projectResource.endDate) ? projectResource.endDate : this.get('endDate'),
		}
	},
	getProjectManagers: function (resources) {
		let result = _.map(this.get('projectManagers'), function (resource) {
			return resource.id;
		});

		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESOURCE_ALLOCATION_PRIMARY_ONLY)) {
			_.each(resources.getProjectManagers(), _.bind(function (resource) {
				if (-resource.id === this.get('userId') && result.indexOf(resource.id) === -1)
					result.push(resource.id);
				if (-resource.id === this.get('user2Id') && result.indexOf(resource.id) === -1)
					result.push(resource.id);
			}, this));
		}

		return result;
	},
	getVisibleSuperintendents: function (startDate) {
		return _.filter(this.get('superintendents'), function (resource) {
			return resource.startDate == null || PJQ.helpers.dateHelpers.parseDateString(resource.endDate, false) >= startDate;
		});
	},
	getProjectManagersDisplay: function (resources) {
		let result = [];
		_.each(this.getProjectManagers(resources), function (id) {
			result.push(resources.get(id).get('contactName'));
		});
		return result.join(', ');
	},
	getProjectLocation() {
		let parts = [];
		parts.push(this.get('city'));
		parts.push(this.get('state'));
		return parts.join(', ');
	},
	getCustomFieldValue(customFieldId) {
		let result = null;
		_.each(this.get('customFields'), function(customField) {
			if (customField.id == customFieldId)
				result = customField.value;
		});

		return result;
	}
});

PJQ.models.resources.ResourceScheduleEvent = PJQ.models.BaseModel.extend({
	idAttribute: 'resourceScheduleId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'resources'
			},
			{
				endpoint: 'schedule'
			},
			{
				endpoint: 'event',
				value: this.id
			}
		]);
	}
});

//Collections
PJQ.collections.resources = {};
PJQ.collections.resources.Resources = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.resources.Resource,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'resources'
			}
		])
	},
	getProjectManagers: function () {
		return _.filter(this.models, function (model) {
			return model.get('isProjectManager');
		});
	},
	getSuperintendents: function () {
		return _.filter(this.models, function (model) {
			return model.get('isSuperintendent');
		});
	}
});

PJQ.collections.resources.Projects = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.resources.Project,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'resources'
			},
			{
				endpoint: 'projects'
			}
		])
	},
	getProjectsAssociatedWithId: function (id, includeProjectsWithoutSchedule = true) {
		return _.filter(this.models, _.bind(function (project) {
			return project.getIsIdAssociated(id) && (includeProjectsWithoutSchedule || (project.get('startDate') && project.get('endDate')));
		}, this));
	},
	getProjectsWithoutSuperintendents(startDate) {
		let endDate = startDate.addDays(12 * 7);

		return _.filter(this.models, function (project) {
			return _.size(project.get('superintendents')) === 0 && (PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false) < endDate && PJQ.helpers.dateHelpers.parseDateString(project.get('endDate'), false) > startDate);
		});
	},
	getProjectManagersWithProjectsAssociatedWithId: function (id, resources, allProjects = true, startDate, events) {
		let result = [];
		_.each(resources, _.bind(function (resource) {

			let endDate = startDate.addDays(12 * 7),
				projects = _.filter(this.getProjectsAssociatedWithId(resource.get('id')), function (project) {
					let projectDates = project.getProjectResourceDates(id);
					return (PJQ.helpers.dateHelpers.parseDateString(projectDates.startDate, false) < endDate && PJQ.helpers.dateHelpers.parseDateString(projectDates.endDate, false) > startDate);
				}),
				filteredProjects = _.filter(projects, function (project) {
					return project.getIsIdAssociated(id);
				});


			if (_.size(filteredProjects) > 0) {
				result.push({
					resource: resource,
					items: allProjects ? projects : filteredProjects
				});
			}
		}, this));

		_.each(events.getEventsForResource(id), _.bind(function (event) {
			result.push({
				resource: {
					id: -event.get('resourceScheduleId'),
					contactName: 'Scheduled Event'
				},
				items: [event]
			});
		}, this));

		return result;
	},
	getSuperintendentsWithProjectsAssociatedWithId: function (id, resources, allProjects = true, startDate, events) {
		let result = [];
		_.each(resources, _.bind(function (resource) {

			let endDate = startDate.addDays(12 * 7),
				projects = _.filter(this.getProjectsAssociatedWithId(resource.get('id')), function (project) {
					let projectDates = project.getProjectResourceDates(resource.get('id'));
					return (PJQ.helpers.dateHelpers.parseDateString(projectDates.startDate, false) < endDate && PJQ.helpers.dateHelpers.parseDateString(projectDates.endDate, false) > startDate);
				}),
				filteredProjects = _.filter(projects, function (project) {
					return project.getIsIdAssociated(id);
				}),
				items = _.sortBy(_.union((allProjects ? projects : filteredProjects), events.getEventsForResource(resource.get('id'))), function (item) {
					return item.get('startDate');
				});

			if (_.size(filteredProjects) > 0) {
				result.push({
					resource: resource,
					projects: allProjects ? projects : filteredProjects,
					items: items
				});
			}
		}, this));

		return result;
	}

});

PJQ.collections.resources.ResourceScheduleEvents = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.resources.ResourceScheduleEvent,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'resources'
			},
			{
				endpoint: 'schedule'
			},
			{
				endpoint: 'events'
			}
		])
	},
	getEventsForResource: function (id) {
		return _.filter(this.models, function (item) {
			return item.get('resourceId') === id;
		});
	}
});